import {
  SET_READY_STATE
} from '@/store/types'

import logsList from './management/logs_list'
import permissionAssignmentsList from './management/permission_assignments_list'
import rolesList from './management/roles_list'
import usersList from './management/users_list'
import userDetails from './management/user_details'
import templatesList from './management/templates_list'

export default {
  namespaced: true,
  modules: {
    logsList,
    permissionAssignmentsList,
    rolesList,
    usersList,
    userDetails,
    templatesList
  },

  state: {
    ready: false
  },
  getters: {},

  mutations: {
    [SET_READY_STATE] (state, ready) {
      state.ready = ready
    }
  },
  actions: {}
}
